import { AuthTranslationType } from "../../features/auth.types";

export const auth: AuthTranslationType = {
  auth: {
    cookieConsent: {
      title: "Soglasje za Piškotke",
      description: "Ta spletna stran uporablja piškotke za izboljšanje vaše izkušnje brskanja. S klikom na 'Sprejmi' se strinjate z uporabo piškotkov v skladu z našo politiko piškotkov.",
      accept: "Sprejmi Piškotke",
      readMore: "Za več informacij preberite naš ",
      privacyPolicy: "Pravilnik o Zasebnosti",
      and: "in",
      termsOfService: "Pogoji Uporabe"
    },
    title: {
      resetPassword: "Ponastavitev Gesla",
      welcome: "Dobrodošli Nazaj"
    },
    form: {
      displayName: "Prikazno Ime",
      email: "E-pošta",
      password: "Geslo",
      newPassword: "Novo Geslo",
      forgotPassword: "Ste pozabili geslo?",
      loading: "Nalaganje...",
      signIn: "Prijava",
      signUp: "Registracija",
      resetPassword: "Ponastavi Geslo",
      sendResetLink: "Pošlji Povezavo za Ponastavitev",
      alreadyHaveAccount: "Že imate račun? Prijava",
      needAccount: "Potrebujete račun? Registracija",
      backToSignIn: "Nazaj na Prijavo",
      orContinueWith: "Ali nadaljujte z",
      google: "Google",
      facebook: "Facebook",
      privacyPolicyAgreement: "S klikom na Registriraj se se strinjate z",
      privacyPolicy: "Politiko Zasebnosti",
      termsAgreement: "in",
      termsOfService: "Pogoji Uporabe"
    },
    toast: {
      missingInfo: {
        title: "Manjkajoče Informacije",
        description: "Prosimo, vnesite e-pošto in geslo."
      },
      missingName: {
        title: "Manjkajoča Informacija",
        description: "Prosimo, vnesite prikazno ime."
      },
      invalidEmail: {
        title: "Neveljavna E-pošta",
        description: "Prosimo, vnesite veljaven e-poštni naslov."
      },
      invalidPassword: {
        title: "Neveljavno Geslo",
        description: "Geslo mora vsebovati vsaj 6 znakov."
      },
      emailNotVerified: {
        title: "E-pošta ni potrjena",
        description: "Prosimo, preverite svoj poštni predal in kliknite na potrditveno povezavo za potrditev e-pošte. Potrebujete novo povezavo?",
        resend: "Ponovno pošlji"
      },
      verificationEmailSent: {
        title: "Potrditveno Sporočilo Poslano",
        description: "Prosimo, preverite svoj poštni predal za potrditveno povezavo."
      },
      loginFailed: {
        title: "Prijava ni uspela",
        description: "Neveljavna e-pošta ali geslo. Poskusite znova ali se registrirajte, če še nimate računa."
      },
      displayNameTaken: {
        title: "Prikazno Ime že Uporabljeno",
        description: "To prikazno ime je že v uporabi. Izberite drugo."
      },
      signUpSuccess: {
        title: "Uspešno",
        description: "Preverite svojo e-pošto za potrditveno povezavo!"
      },
      userAlreadyRegistered: {
        title: "Registracija ni uspela",
        description: "Ta e-pošta je že registrirana. Poskusite se prijaviti."
      },
      resetEmailSent: {
        title: "Preverite svojo e-pošto",
        description: "Poslali smo vam povezavo za ponastavitev gesla. Prosimo, preverite svoj poštni predal."
      },
      resetSuccess: {
        title: "Uspešno",
        description: "Vaše geslo je bilo uspešno ponastavljeno. Prosimo, prijavite se z novim geslom."
      },
      error: {
        title: "Napaka",
        description: "Prišlo je do nepričakovane napake. Poskusite znova."
      },
      googleLoginError: {
        title: "Napaka pri prijavi Google",
        description: "Prijava z Google ni mogoča. Poskusite znova."
      },
      facebookLoginError: {
        title: "Napaka pri prijavi Facebook",
        description: "Ni mogoče začeti prijave s Facebookom. Poskusite znova."
      },
      samePassword: {
        title: "Napaka",
        description: "Novo geslo ne sme biti enako trenutnemu geslu."
      },
      agreementRequired: {
        title: "Zahtevano soglasje",
        description: "Za nadaljevanje se morate strinjati s pogoji uporabe in politiko zasebnosti."
      },
    }
  }
};
